import { CanActivateFn } from '@angular/router';
import { DataPermission, isPrivileged } from '../user-context/user-context.model';
import { deniedUrl } from './denied-url';
import { withUserContext } from './with-user-context';

/**
 * Prevents authorized users from reaching a data type (employee vs pre-hire) they
 * are not assigned (FDD §4.3). Privileged roles (POC / NABP Admin / NABP Staff)
 * bypass. Fails closed to /unauthorized (SECURITY-08); during an org-switch reload an
 * unassigned data type goes to the landing page instead (see deniedUrl).
 */
export const dataTypeGuard: CanActivateFn = (route) => {
  const required = route.data['dataType'] as DataPermission | undefined;
  const denied = deniedUrl();

  return withUserContext((context) =>
    !required || isPrivileged(context.role) || context.assignedDataTypes.includes(required)
      ? true
      : denied,
  );
};
